import { render, staticRenderFns } from "./modal_comparision.vue?vue&type=template&id=8c3a3f60"
import script from "./modal_comparision.vue?vue&type=script&lang=js"
export * from "./modal_comparision.vue?vue&type=script&lang=js"
import style0 from "./modal_comparision.vue?vue&type=style&index=0&id=8c3a3f60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports